module.exports = __webpack_public_path__ + "static/media/4_multifiber_A_yellow_square.9bcc0047.png";